import {
    CHINA_INTERPRETER_RESET,
    CHINA_INTERPRETER_SET_PACEPRO,
    CHINA_INTERPRETER_SET_PACEPROCREATE,
    CHINA_INTERPRETER_SET_POWERGUIDANCE,
    CHINA_INTERPRETER_SET_POWERGUIDANCE_ALGO_DATA
} from './ActionTypes';

export const chinaInterpreterSetPacePro = (payload) => ({
    type: CHINA_INTERPRETER_SET_PACEPRO,
    payload
});

export const chinaInterpreterSetPaceProCreate = (payload) => ({
    type: CHINA_INTERPRETER_SET_PACEPROCREATE,
    payload
});

export const chinaInterpreterSetPowerGuidance = (payload) => ({
    type: CHINA_INTERPRETER_SET_POWERGUIDANCE,
    payload
});

export const chinaInterpreterSetPowerGuidanceAlogorithmData = (payload) => ({
    type: CHINA_INTERPRETER_SET_POWERGUIDANCE_ALGO_DATA,
    payload
});

export const chinaInterpreterReset = () => ({
    type: CHINA_INTERPRETER_RESET
});
